module.exports = __webpack_public_path__ + "img/bedroom_full.676c6cb3.jpg";